module.exports = __webpack_public_path__ + "static/machine-learing-course-c0d7c219f5309cf303713bcae2da8608.svg";